import { api, ApiError } from "@/api/api";
import { PostEpisodeData } from "@/api/episodes-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useGenerateStories({ onSuccess }: { onSuccess: () => void }) {
  const queryClient = useQueryClient();

  return useMutation<object, ApiError, PostEpisodeData>({
    mutationKey: ["POST", "generateStories"],
    mutationFn: api.stories.post,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      onSuccess();
    },
  });
}
